import { cloneDeep } from 'lodash';

import { BUSINESS_STRUCTURE, PRIVATE_OR_PUBLIC, RELATED_COMPANY_TYPE, TRUST_TYPE } from '@funnels/constants';
import { Company } from '@funnels/types';

export const COMPANY_MOCK_DATA: Company[] = [
  {
    type: RELATED_COMPANY_TYPE.EMPLOYER,
    id: 'company-1',
    clientId: 'company-1',
    abn: 25008526461,
    abnVerified: true,
    businessName: 'Decentralized Systems1',
    address: {
      city: 'Sydney',
      country: 'Australia',
      formatted: 'Level 9, 50 Pitt St, Sydney, NSW 2000, Australia',
      postcode: '2000',
      standard: {
        buildingName: 'Opera House',
        deliveryAddress: 'PO Box 1',
        level: 'Level 9',
        lotSection: 'Lot 49',
        streetName: 'Pitt',
        streetNumber: '50',
        streetSuffix: 'North',
        streetType: 'Street',
        unit: 'Unit 1',
      },
      state: 'NSW',
    },
    businessStructure: BUSINESS_STRUCTURE.COMPANY,
    phone: '0400123456',
    privateOrPublic: PRIVATE_OR_PUBLIC.PRIVATE,
  },
  {
    id: 'company-2',
    clientId: 'company-2',
    type: RELATED_COMPANY_TYPE.SELF_EMPLOYMENT_BUSINESS,
    abn: 18611161856,
    abnVerified: true,
    address: {
      city: 'Sydney',
      country: 'Australia',
      formatted: 'L9 50 Pitt St, Sydney, NSW 2000, Australia',
      postcode: '2000',
      standard: {
        level: 'L 9',
        streetName: 'Pitt',
        streetNumber: '50',
        streetType: 'St',
      },
      state: 'NSW',
    },
    businessName: 'LENDI PTY LTD',
    businessStructure: BUSINESS_STRUCTURE.TRUST,
    gstRegisteredDate: '2016-07-01',
    owners: [
      {
        applicantId: 'applicant-1',
        percentOwned: 0.3,
      },
      {
        applicantId: 'applicant-2',
        percentOwned: 0.5,
      },
    ],
    phone: '1300 323 181',
    privateOrPublic: PRIVATE_OR_PUBLIC.PRIVATE,
    trustType: TRUST_TYPE.CASH_MANAGEMENT_TRUST,
  },
  {
    id: 'company-3',
    clientId: 'company-3',
    type: RELATED_COMPANY_TYPE.SELF_EMPLOYMENT_BUSINESS,
    abn: 33311161856,
    abnVerified: true,
    address: {
      city: 'Sydney',
      country: 'Australia',
      formatted: 'L9 50 Pitt St, Sydney, NSW 2000, Australia',
      postcode: '2000',
      standard: {
        level: 'L 9',
        streetName: 'Pitt',
        streetNumber: '50',
        streetType: 'St',
      },
      state: 'NSW',
    },
    businessName: 'LENDI PTY LTD 111',
    businessStructure: BUSINESS_STRUCTURE.PARTNERSHIP,
    gstRegisteredDate: '2013-07-01',
    owners: [
      {
        applicantId: 'applicant-2',
        percentOwned: 0.5,
      },
    ],
    phone: '1111 323 181',
    privateOrPublic: PRIVATE_OR_PUBLIC.PRIVATE,
    trustType: TRUST_TYPE.CASH_MANAGEMENT_TRUST,
  },
];

export const getMockCompanies = (): Company[] => cloneDeep(COMPANY_MOCK_DATA);
